// config.js

export const siteConfig = {
  title: "Piedmont Adult Day Program",
  metaDescription: "Piedmont Adult Day Program",
  theme: {
    primaryColor: "green-500",
    secondaryColor: "gray-200",
    accentColor: "text-green-500"
  },
};
